<template>
    <div class="card mb-2">
        <b-overlay
        :show="isLoading"
        spinner-variant="primary"
        rounded="sm"
        >
            <b-card-body>
                <b-row >
                    <b-form-group
                        id="input-announcements-id"
                        :label="$t('parametrics.announcementsId')"
                        label-for="input-id"
                        label-align="left"
                        class="col-lg-1 col-md-2"
                    >
                        <b-form-input
                            id="input-id"
                            type="text"
                            v-model="announcement.id"
                            disabled
                            placeholder=""
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="input-announcement-add"
                        :label="$t('parametrics.announcementTitle')"
                        label-for="input-title"
                        label-align="left"
                        class="col-8"
                        >
                            <b-form-input
                                    id="input-title"
                                    type="text"
                                    v-model="announcement.title"
                                    placeholder=""
                            />
                    </b-form-group>
                
                </b-row>
                <b-row>
                    <b-form-group
                        id="input-participationTemplate-participationText"
                        :label="$t('parametrics.participationTemplateTitle')"
                        label-for="input-participationText"
                        label-align="left"
                        class="col-12"
                    >
                      <ckeditor
                          id="input-participationText"
                          v-model="announcement.eligibilitySection"
                          :editor="editor" />
                    </b-form-group>
                </b-row>
                <b-row>
                    <b-form-group
                        id="input-participationTemplate-participationDecleration"
                        :label="$t('parametrics.participationDeclerationTitle')"
                        label-for="input-participationDeclearation"
                        label-align="left"
                        class="col-12"
                    >
                      <ckeditor
                          id="input-participationDeclearation"
                          v-model="announcement.applicationInfoSection"
                          :editor="editor" />
                    </b-form-group>
                </b-row>



                <b-row>
                    <b-form-group
                    id="input-announcement-information"
                    :label="$t('parametrics.announcementInformation')"
                    label-for="input-information"
                    label-align="left"
                    class="col-12"
                    >
                      <ckeditor
                          id="input-information"
                          v-model="announcement.commentsSection"
                          :editor="editor" />
                    </b-form-group>
                </b-row>
                <b-row v-if="!announcement.archived">
                    <b-button @click="saveAnnouncement" variant="success" class="float-left" v-if="announcement.id!=null && !announcement.archived">{{
                        $t("common.save")
                    }}
                    </b-button>
                    <b-button @click="createAnnouncement" variant="success" class="float-left" :disabled='!announcement.title' v-else>{{
                        $t("common.submit")
                    }}
                    </b-button>
                </b-row>
            </b-card-body>
        </b-overlay>
    </div>
</template>

<script>
import trainingService from '../../services/training.service';
import {handleApiError} from "../../services/error.service";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
    props: {
        announcement: Object
    },
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component
  },
    data(){
        return{
            reqAnnouncementToAdd: {
                announcement: this.announcement,
                prerequisiteAnnouncement: null
            },
            isLoading: false,
          editor: ClassicEditor,
        }
    },
    methods: {
        createAnnouncement() {
            this.isLoading = true;
            trainingService.createAnnouncement(this.announcement).then(
                (response) => {
                this.$log.debug(response.data);
                this.$store.state.AnnouncementJustCreated = true;
                this.$router.push({name: 'announcementsEdit', params: {id: response.data.id}});
                this.isLoading = false;
                },
                (error) => {
                let errorMessage = handleApiError(error);
                this.$emit('error:api', errorMessage);
                this.isLoading = false;
                }
                
            )
        },
        saveAnnouncement() {
            this.isLoading = true;
            trainingService.updateTemplate(this.announcement).then(
                () => {
                this.$emit('emit-success', this.$t('parametrics.announcementSaved'));
                this.isLoading = false;
                },
                (error) => {
                let errorMessage = handleApiError(error);
                this.$emit('error:api', errorMessage);
                this.isLoading = false;
                }
            )
        }
    },
}
</script>